import { Component, Input, OnChanges, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
} from '@angular/forms';
import { DropdownItem } from '../../models/commonModel';
import { PaymentTab } from '../../models/exemptionFilling';
@Component({
  selector: 'app-paymenttab',
  templateUrl: './paymenttab.component.html',
  styleUrls: ['./paymenttab.component.scss']
})
export class PaymenttabComponent implements OnInit, OnChanges {

  @Input()
  PaymentTab!: FormGroup;
  @Input()
  OnlinePayment!: PaymentTab | undefined;
  @Input()
  ParentForm!: FormGroup;
  @Input() 
  PaymentTypes!: DropdownItem[];
  @Input()
  CityTypes!: DropdownItem[];
  @Input()
  StateTypes!: DropdownItem[];
  isOnlinePayment = false;
  billingAddress = "";
  constructor(
    private formBuilder: FormBuilder
  ) {
    // this.paymentTabs = this.formBuilder.group({
    // });
  }

  ngOnInit(): void {
  }
  getValue(tabName: string, fieldName: string) {
    return (this.ParentForm.controls[tabName] as FormGroup)?.controls[fieldName]
      .value;
  }
  ngOnChanges(): void {
    if (this.OnlinePayment) {
      this.billingAddress = this.getBillingAddress();
    }
  }
  getApplicantName() {
    var fname = this.getValue('QualificationTab', 'firstName') || '';
    var lname = this.getValue('QualificationTab', 'lastName') || '';
    return `${fname} ${lname}`;
  }

  getMailingAddress() {
    var addr1 = this.getValue('MailingAddressTab', 'address1');
    var addr2 = this.getValue('MailingAddressTab', 'address2');
    var city = this.getValue('MailingAddressTab', 'city');
    var state = this.getState(this.getValue('MailingAddressTab', 'stateId'));
    var zip = this.getValue('MailingAddressTab', 'zipCode');

    return `${addr1 ? addr1 + '\n' : ''} ${addr2 ? addr2 + '\n' : ''} 
              ${city ? city + ', ' : ''}  ${state ? state : ''} ${
      zip ? zip : ''
    }`;
  }

  getCity(cityId: any) {
    if (!cityId) return;
    console.log(cityId);
    console.log(this.CityTypes.find((x) => x.id == cityId)?.name);
    return this.CityTypes.find((x) => x.id == cityId)?.name;
  }
  getState(stateId: any) {
    if (!stateId) return;
    return this.StateTypes.find((x) => x.id == stateId)?.abbrv;
  }

  getBillingAddress() {
    var addr1 = this.OnlinePayment?.fisBillingAddress;
    var city = this.OnlinePayment?.fisBillingCity;
    var state = this.OnlinePayment?.fisBillingState;
    var zip = this.OnlinePayment?.fisBillingZip;

    return `${addr1 ? addr1 + '\n' : ''}
              ${city ? city + ', ' : ''}  ${state ? state : ''} ${
      zip ? zip : ''
    }`;
  }
}
